import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ServiceintervalDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceinterval-dto';

import { ServiceintervalChartItem } from 'src/app/components/aftale/models';

@Component({
    selector: 'app-serviceinterval-bar-graph',
    templateUrl: './serviceinterval-bar-graph.component.html',
    styleUrls: ['./serviceinterval-bar-graph.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ServiceintervalBarGraphComponent implements OnInit {
  @Input() altbar: boolean;
  @Input() label: string;

  _onset: ServiceintervalChartItem[];

  get onset(): ServiceintervalChartItem[] {
    return this._onset;
  }
  @Input() set onset(value: ServiceintervalChartItem[]) {
    this._onset = value;
  }

  _months: ServiceintervalChartItem[];
  get months(): ServiceintervalChartItem[] {
    return this._months;
  }
  @Input() set months(value: ServiceintervalChartItem[]) {
    this._months = value;
  }

  _offset: number = 0;
  get offset(): number {
    return this._offset;
  }
  @Input() set offset(value: number) {
    this._offset = value;
    if (this.offset) {
      this.offsetPx = (this.offset > 0 ? this.offset + 1 : 0) * 16 + 'px';
    }
  }

  _serviceinterval: ServiceintervalDto;
  get serviceinterval(): ServiceintervalDto {
    return this._serviceinterval;
  }
  @Input() set serviceinterval(value: ServiceintervalDto) {
    this._serviceinterval = value;
  }

  offsetPx: string;

  constructor() {}

  ngOnInit(): void {}

  getToolTip(m: ServiceintervalChartItem) {
    return m.comments.join('\n');
  }
}
